import { NativeAudio } from "@ionic-native/native-audio";
import { HomePage } from "./../home/home";
import { TranslateService } from "@ngx-translate/core";
import { PlazaSelectPlanPage } from "./../plaza-select-plan/plaza-select-plan";
import { RequestOptions, Http, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";
import { SelectSearchableComponent } from "ionic-select-searchable";

class Shop {
  public id: number;
  public name: string;
}
@IonicPage()
@Component({
  selector: "page-plaza-select-plan-invest",
  templateUrl: "plaza-select-plan-invest.html",
})
export class PlazaSelectPlanInvestPage {
  space: any;
  shops: Shop[];
  shop: Shop;
  desc: any = { cost: "", opex: "", capacity: "", total_cost: "" };
  social_shop_id: any;
  shop_id: any;
  url: any;
  budget: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private nativeAudio: NativeAudio,
    private loadingCtrl: LoadingController
  ) {
    this.space = this.navParams.data.space.space_no;
    this.nativeAudio.preloadSimple("uniqueId2", "assets/sounds/cash.aac");
  }

  shopChange(event: { component: SelectSearchableComponent; value: any }) {
    let res = event.value;
    this.shop_id = res.social_shop_id;
    this.desc.cost = this.services.currencyFormat(res.cost);
    this.desc.opex = this.services.currencyFormat(res.opex);
    this.desc.capacity = res.capacity;
    let total_cost = parseFloat(res.cost) + parseFloat(res.opex);
    this.desc.total_cost = this.services.currencyFormat(total_cost);
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      this.storage.get("socialSelected").then((socialSelected) => {
        var link = this.services.URLShopsSocial;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.shops = data.filter(
                (x) => socialSelected.indexOf(x.social_shop_id) === -1
              );
              loader.dismiss();
            },
            (error) => {
              var response = JSON.parse(error._body);
              loader.dismiss();
              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );

        this.storage.get("info").then((info) => {
          if (info.role == 1) {
            this.url = this.services.URLPlazaStatBudgets;
          } else if (info.role == 2) {
            this.url = this.services.URLMerchantStatBudgets;
          } else if (info.role == 3) {
            this.url = this.services.URLShopperStatBudgets;
          }
          var link = this.url;

          this.http
            .get(link, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                this.budget = this.services.currencyFormat(data.available);
              },
              (error) => {
                // console.log(error);
                this.services.presentToastInternet();
              }
            );
        });
      });
    });
  }

  confirm() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      let body = "space_no=" + this.space + "&social_shop_id=" + this.shop_id;

      var link = this.services.URLPostSocial;
      var headers = new Headers();
      headers.append("Content-Type", "application/x-www-form-urlencoded");
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .post(link, body, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            loader.dismiss();
            this.nativeAudio.play("uniqueId2");
            this.navCtrl.push(PlazaSelectPlanPage);
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-plan-invest/plaza-select-plan-invest.ts